import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getDefaultHomeThunk } from '../thunks/default-home.thunk';
import { RequestStatus } from '../../../interface';
import { selectDefaultHomeState } from '../selectors/default-home.selectors';
export const useDefaultHome = () => {
  const dispatch = useAppDispatch();
  const {
    homeKey,
    status,
    error
  } = useAppSelector(selectDefaultHomeState);
  useEffect(() => {
    void dispatch(getDefaultHomeThunk());
  }, [dispatch, status]);
  return {
    homeKey,
    loading: status === RequestStatus.LOADING || status === RequestStatus.IDLE,
    error
  };
};